import React, { useState } from 'react';
import {
  Box,
  Button,
  VStack,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  HStack,
  useColorModeValue,
  Divider,
} from "@chakra-ui/react";

import { Link } from 'react-router-dom';

import { FaHome, FaRegUser, FaChartBar, FaRegCalendarAlt,FaCalendarAlt,FaUniversity, FaUserAlt, FaUserFriends,FaWallet,FaCog, FaChevronDown } from "react-icons/fa";
import PrivateSidebarLayout from '../../Platform/Common/PrivateSidebarLayout';
import StudentSideBarLayout from '../Student/Layouts/StudentSideBarLayout';


  const B2CAssessorSideBar = () => {
    
    const sidebarBg = useColorModeValue("gray.100", "gray.600");


    //const tenantSlug = localStorage.getItem("tenantSlug");

    console.log('Current theme mode on Services Page', sidebarBg);
    return (
      <StudentSideBarLayout>
        <VStack spacing={1} align="stretch" >
           
           <Button mt = {4} as={Link} to={`/practice/app/tutor-calendar`} variant="ghost" >
          <VStack spacing={2}>
                <FaRegCalendarAlt />
                <Text fontWeight="normal"  fontSize="12">My Calendar</Text>
                </VStack>
          </Button>
          <Divider orientation='horizontal'/>
          <Button mt = {4} as={Link} to={`/practice/app/tutor-batches`} variant="ghost" >
          <VStack spacing={2}>
                <FaUserFriends />
                <Text fontWeight="normal"  fontSize="12">Batch Management</Text>
                </VStack>
          </Button>
          <Divider orientation='horizontal'/>
         
           <Button mt = {4} as={Link} to={`/practice/app/tutor-upcoming-classes`} variant="ghost" >
          <VStack spacing={2}>
                <FaUniversity />
                <Text fontWeight="normal"  fontSize="12">Upcoming Classes</Text>
                </VStack>
          </Button>
          <Divider orientation='horizontal'/>
      
           <Button mt = {4} as={Link} to={`/practice/app/tutor-exams`} variant="ghost" >
          <VStack spacing={2}>
                <FaUserFriends />
                <Text fontWeight="normal"  fontSize="12">Exams in Scoring</Text>
                </VStack>
          </Button>
          <Divider orientation='horizontal'/>
          
        </VStack>
        </StudentSideBarLayout>
    );
  }
  export default B2CAssessorSideBar;

 